import {
  MentionNotificationMeta,
  Notification,
  parseNotificationText,
} from "../../../../../models/Notification";
import clsx from "clsx";
import { MessageRenders } from "../../../../ednaConversations/components/MessageRenders/MessageRenders";
import { forwardRef, useImperativeHandle } from "react";
import { useStore } from "../../../../../stores";
import { useHistory } from "react-router";
import { EdnaChatType } from "../../../../../models/EdnaChat";
import routes from "../../../../../constants/routes";

type Props = {
  notification: Notification;
};

type RefProps = {
  onClick: () => void;
};

export const MentionParser = forwardRef<RefProps, Props>(
  ({ notification }, ref) => {
    const { selectedWorkspace } = useStore("workspaces");
    const { markAsRead } = useStore("notifications");
    const { user } = useStore("auth");
    const history = useHistory();

    const meta = notification.meta as MentionNotificationMeta;

    const onClick = () => {
      if (!notification.readAt) {
        markAsRead(String(notification.id));
      }

      let userId;
      const chatType = meta.chat.threadChatType ?? meta.chat.type;

      if (chatType === EdnaChatType.SINGLE) {
        userId = meta.chat.room.split("|").find((f) => f !== user?.id);
      } else if (chatType === EdnaChatType.CHANNEL) {
        userId = meta.chat.room.replace("livecard-", "");
      } else if (chatType === EdnaChatType.CHATHUB_CHAT) {
        history.push(
          routes.chats
            .replace(":workspaceId", String(selectedWorkspace?.id))
            .replace(":functionId", "op")
            .replace(":chatId?", meta.chat.room.replace("chathub-chat-", "")) +
            "?notes=open"
        );
        return;
      }

      history.push(
        routes.teammates
          .replace(":workspaceId", String(selectedWorkspace?.id))
          .replace(
            ":userId?",
            String(userId) +
              (meta.chat.threadMessageId
                ? "?thread=" + meta.chat.threadMessageId
                : "")
          )
      );
    };

    useImperativeHandle(ref, () => ({
      onClick,
    }));

    return (
      <>
        <div
          className="title mb-2"
          style={{
            fontSize: 12,
          }}
        >
          {parseNotificationText(notification)}
        </div>
        <div>
          <span
            style={{
              fontSize: 12,
            }}
            className={clsx("has-long-text has-text-weight-medium")}
          >
            <MessageRenders message={meta.message.message} />
          </span>
        </div>
      </>
    );
  }
);
